export class dbErrorEntry {
    public constructor(init?: Partial<dbErrorEntry>) {
      Object.assign(this, init);
    }
      errorMessage: string;
      Location: string;
   }